import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GestionExpedientesComponent } from './gestion-expedientes/gestion-expedientes.component';
import { DetalleSupersociedadesComponent } from './detalle-supersociedades/detalle-supersociedades.component';
import { DetalleSuperfinancieraComponent } from './detalle-superfinanciera/detalle-superfinanciera.component';
import { UtilModule } from '../util/util.module';
import { CoreModule } from '../core/core.module';
import { DetalleIcaComponent } from './detalle-ica/detalle-ica.component';
import { DetalleSupersaludComponent } from './detalle-supersalud/detalle-supersalud.component';
import { DetalleDndaComponent } from './detalle-dnda/detalle-dnda.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetalleDimarComponent } from './detalle-dimar/detalle-dimar.component';
import { DetalleSicComponent } from './detalle-sic/detalle-sic.component';
import { AvanceProcesalComponent } from './avance-procesal/avance-procesal.component';
import { AppRoutingModule } from '../../app-routing.module';
import { RouterModule } from '@angular/router';
import { DetalleAvanceProcesalComponent } from './detalle-avance-procesal/detalle-avance-procesal.component';
import { AnexosAvanceProcesalComponent } from './anexos-avance-procesal/anexos-avance-procesal.component';
import { DescargaDocumentosComponent } from './descarga-documentos/descarga-documentos.component';
import { SolicitudDocumentosComponent } from './solicitud-documentos/solicitud-documentos.component';
import { EncabezadoExpedienteComponent } from './encabezado-expediente/encabezado-expediente.component';
import { AuthModule } from '../auth/auth.module';
import { DetalleSupersociedadesMercantilesComponent } from './detalle-supersociedades-mercantiles/detalle-supersociedades-mercantiles.component';
import { TranslatePipe } from '@ngx-translate/core';
import { GestionExpedienteAdministradorComponent } from './gestion-expediente-administrador/gestion-expediente-administrador.component';
import { ExpedientesSegundaInstanciaComponent } from './expedientes-segunda-instancia/expedientes-segunda-instancia.component';
import { ModalAgregarEntidadSegundaInstanciaComponent } from './modal-agregar-entidad-segunda-instancia/modal-agregar-entidad-segunda-instancia.component';
import { GestionPermisosExpedienteComponent } from './gestion-permisos-expediente/gestion-permisos-expediente.component';
import { DetalleSupersociedadesInsolvenciaComponent } from './supersociedades-insolvencia/detalle-supersociedades-insolvencia/detalle-supersociedades-insolvencia.component';
import { DocumentosSupersociedadesInsolvenciaComponent } from './supersociedades-insolvencia/documentos-supersociedades-insolvencia/documentos-supersociedades-insolvencia.component';
import { DetalleProcesoInsolvenciaComponent } from './supersociedades-insolvencia/detalle-proceso-insolvencia/detalle-proceso-insolvencia.component';

@NgModule({
  declarations: [
    GestionExpedientesComponent,
    DetalleDimarComponent,
    DetalleSicComponent,
    DetalleSupersociedadesComponent,
    DetalleSuperfinancieraComponent,
    DetalleDndaComponent,
    DetalleIcaComponent,
    DetalleSupersaludComponent,
    AvanceProcesalComponent,
    DetalleAvanceProcesalComponent,
    AnexosAvanceProcesalComponent,
    DescargaDocumentosComponent,
    SolicitudDocumentosComponent,
    EncabezadoExpedienteComponent,
    DetalleSupersociedadesMercantilesComponent,
    GestionExpedienteAdministradorComponent,
    ExpedientesSegundaInstanciaComponent,
    ModalAgregarEntidadSegundaInstanciaComponent,
    DetalleSupersociedadesInsolvenciaComponent,
    DocumentosSupersociedadesInsolvenciaComponent,
    GestionPermisosExpedienteComponent,
    DetalleProcesoInsolvenciaComponent,
  ],
  imports: [
    CommonModule,
    UtilModule,
    CoreModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    AppRoutingModule,
    AuthModule,
    TranslatePipe,
  ],
  exports: [
    GestionExpedientesComponent,
    DetalleDimarComponent,
    DetalleSicComponent,
    DetalleSupersociedadesComponent,
    DetalleSuperfinancieraComponent,
    DetalleDndaComponent,
    DetalleIcaComponent,
    DetalleSupersaludComponent,
    DetalleAvanceProcesalComponent,
    AnexosAvanceProcesalComponent,
    DescargaDocumentosComponent,
    EncabezadoExpedienteComponent,
    GestionExpedienteAdministradorComponent,
    ExpedientesSegundaInstanciaComponent
  ],
})
export class ExpedienteModule {}
